<template>
  <div
    class="c-progress"
    :class="{ 'c-progress--small': small, 'c-progress--rounded': rounded }"
    :style="{ backgroundColor: bgc }"
  >
    <div
      class="c-progress__value btn-primary"
      :class="{
        'c-progress__value--small': small,
        'c-progress__value--rounded': rounded
      }"
      :style="{ width: convertedValue + '%', backgroundColor: colorProgress }"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
function hexToRgbA(hex) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",0.14)"
    );
  }
  throw new Error("Bad Hex");
}
export default {
  name: "Progress",
  computed: {
    ...mapGetters(["colors", "campaign"]),
    convertedValue() {
      if (this.value >= 100) {
        return 100;
      }
      return this.value;
    },
    primary() {
      return this.campaign.css_settings.primary;
    },
    bgc() {
      if (this.background) {
        return this.background;
      }
      return hexToRgbA(this.primary);
    },
    colorProgress() {
      if (this.color) {
        return this.color;
      }
      return this.primary;
    }
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    small: {
      type: Boolean,
      default: false
    },
    background: {
      type: String
    },
    color: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.c-progress {
  width: 100%;
  height: 8px;
  position: relative;
  overflow: hidden;
}
.c-progress__value {
  height: 8px;
  position: absolute;
  top: 0;
  left: 0;
  transition: 0.5s all;
}
.c-progress--small {
  height: 2px;
}
.c-progress__value--small {
  height: 4px;
  top: -1px;
}
.c-progress--rounded {
  border-radius: 20px;
}
.c-progress__value--rounded {
  border-radius: 20px;
}
</style>
